import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DwMdSectionConfigBaseComponent, DwComponentSectionConfigPreference, DwMdItem, DwMdAttribute, DwContextMetaData, DwQueryMdAttribute, DwPageConfigBaseComponent } from '@devwareapps/devware-cap';
import { PowerBiGridConfig } from '../models/power-bi-grid-config';


@Component({
  selector: 'app-power-bi-grid-config',
  templateUrl: './power-bi-grid-config.component.html'
})
export class PowerBiGridConfigComponent extends DwPageConfigBaseComponent<PowerBiGridConfig> {
  itemMetaData: DwMdItem;
  configFormGroup: FormGroup;

  setupForm() {
    //this.setupAttributeList();
    //this.setupContextList();
    this.configFormGroup = new FormGroup({
      reportId: new FormControl(),
      workspaceId: new FormControl(),
      tableNames: new FormControl(),
      passGridEvents: new FormControl(),
      passUserId: new FormControl(),
      height: new FormControl(),
    })
    //this.configFormGroup.addControl('config', this.configFormGroup);
  }


// setupAttributeList() {
//   this.getItemMetaData(this.itemName)
//     .subscribe(itemMetaData => {
//       this.itemMetaData = itemMetaData;
//     });
// }

// setupContextList(){
//   this.contextNames.forEach(contextName => {
//     this.dwContextService.getContextMetaData(contextName).subscribe(x => {

//       x.attributes.forEach(y =>{
//         this.contextMetaData.push({dwQueryMdAttribute: y, dwContextMetaData: x});
//         //this.contextMetaData[0].dwContextMetaData.contextDef.contextDisplay
//       })
//     })
//   })
// }

}
